import { sfwUrl } from "./env";
import { routes } from "@/common/utils/routes";
import { loadRedditAppVisit } from "@/common/utils/storage";
import { getDeviceType, deviceTypeEnum, getWindowWidth } from "@/common/utils/device";

interface GeoRule {
  readonly allowedPages: string[];
  readonly redirectTo: string;
}

const COMMON_ALLOWED_PAGES = [
  "/auth/signin",
  "/guidelines",
  "/ifr/",
  "/user/verify",
];

const blockedStates = [
  "alabama",
  "florida",
  "georgia",
  "indiana",
  "kansas",
  "louisiana",
  "oklahoma",
  "south carolina",
  "south dakota",
  "tennessee",
  "texas",
];

const blockedCountries = [
  "GB"
];

export const STATE_RULES = new Map<string, GeoRule>();
const COUNTRY_RULES = new Map<string, GeoRule>();

blockedStates.forEach(state => {
  const pageState = routes.geoBlockedPage(state.replace(" ", "-"));

  STATE_RULES.set(state, {
    allowedPages: [pageState, ...COMMON_ALLOWED_PAGES],
    redirectTo: pageState,
  });
});

blockedCountries.forEach(country => {
  COUNTRY_RULES.set(country, {
    allowedPages: [...COMMON_ALLOWED_PAGES],
    redirectTo: sfwUrl,
  });
});

export const isPageAllowed = (pathname: string, country?: string | null, state?: string | null): boolean => {
  const isMobile = getDeviceType(getWindowWidth()) === deviceTypeEnum.PHONE;

  if (loadRedditAppVisit() && isMobile && country === "GB") {
    return true; // Reddit app users from Great Britain can access all pages
  }

  if (COMMON_ALLOWED_PAGES.some((page) => pathname.startsWith(page))) {
    return true; // Common pages e.g. guidelines are always allowed
  }

  if (country === undefined && state === undefined) {
    return false; // Location not determined yet, block by default
  }

  const rule = (state && STATE_RULES.get(state)) || (country && COUNTRY_RULES.get(country));

  if (!rule || rule.allowedPages.some((page) => pathname.startsWith(page))) {
    return true; // No rule or page is allowed
  }

  return false;
};

export const getAlternatePage = (pathname: string, country?: string | null, state?: string | null): string | null => {
  if (!isPageAllowed(pathname, country, state)) {
    const rule = getRule(country, state);

    if (rule) {
      return rule.redirectTo;
    }
  }

  return null;
};

const getRule = (country?: string | null, state?: string | null) => {
  return (state && STATE_RULES.get(state)) || (country && COUNTRY_RULES.get(country));
};
